import { ICONES_FACETA } from '@/global/components/EscopoFuncionario/Cascata'
import { SelectFuncionarios } from 'global/components/Selects'
import { useFormContext } from 'react-hook-form'
import { type CondicaoUi, contar } from './condicao-ui'

function ParametrosFuncionario() {
    const { getValues } = useFormContext()

    return (
        <SelectFuncionarios
            variant="form"
            form="parametros.funcionarioIds"
            defaultValues={getValues('parametros.funcionarioIds')}
        />
    )
}

export const funcionario: CondicaoUi = {
    icone: ICONES_FACETA.funcionarios,
    parametrosIniciais: { funcionarioIds: [] },
    Parametros: ParametrosFuncionario,
    resumir: parametros =>
        contar(parametros.funcionarioIds, 'funcionário', 'funcionários'),
}
